import styled from 'styled-components';


export default styled.div`
  color: #000000;
  text-align: center;
  position: absolute;
  opacity: 1;
  z-index: 99999999999;
  background: rgb(255 255 255 / 40%);
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.6rem;
  font-weight: 400;
`;
